module.exports = __webpack_public_path__ + "static/img/logo.72683f64.svg";